module.exports = __webpack_public_path__ + "img/jilu.82036772.png";